"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFilterInstantCellFactory = exports.FilterInstantCell = void 0;
const react_1 = __importDefault(require("react"));
const instant_field_1 = require("../../../components/instant-field/instant-field");
const filter_interval_cell_factory_1 = require("./filter-interval-cell-factory");
exports.FilterInstantCell = filter_interval_cell_factory_1.filterIntervalCellFactory(instant_field_1.InstantField);
function useFilterInstantCellFactory(representation) {
    const Field = (props) => (react_1.default.createElement(instant_field_1.InstantField, Object.assign({}, props, { representation: representation })));
    return filter_interval_cell_factory_1.filterIntervalCellFactory(Field);
}
exports.useFilterInstantCellFactory = useFilterInstantCellFactory;
//# sourceMappingURL=filter-instant-cell.js.map